import { Box, IconButton, InputAdornment, Stack, TextField, Typography, Grid } from '@mui/material';
import { AgGridTable } from 'components/tables/AgGridTable';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatTimestampToDate24Hours } from 'utilities/common';
import AngleRightIcon from 'common/customIcons/angle_right';
import SearchIcon from 'common/customIcons/search';
import { CloseRounded } from '@mui/icons-material';
import { useDebounce } from 'hooks/useDebounce';
import { fetchBRBGraphicsLogs } from '../../../../redux/slices/hyperwolf/settings';
import CommonLayout from 'layouts/DashboardLayout';
import defaultImage from 'assets/images/placeholder-image.png';


export default function BRBLogs() {
    const dispatch = useDispatch();
    const { logsloading: loading, slotsLogs = {}, isLoading } = useSelector(state => state.hyperwolfSettings);
    const searchTermRef = useRef('');
    const mainGridApiRef = useRef('');
    const gridRefApi = useRef(null);
    const pageRef = useRef(0);
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState("");

    const columnDefs = [
        {
            headerName: 'Action Type',
            field: 'logsType',
            key: 'fullName',
            suppressMenu: false,
            cellRenderer: useCallback((props) => (
                props?.value ? props?.value : '-'

            ), []),
            minWidth: 180,
            sortable: false
        },

        {
            headerName: 'Region',
            field: 'newChanges',
            minWidth: 180,
            cellRenderer: (props) => {
                return props?.value?.regionName ? `${props?.value?.regionName}` : '-';
            },
            flex: 1.3,
            sortable: false
        },
        {
            headerName: 'Old Value',
            field: 'previousChanges',
            suppressMenu: false,
            cellRenderer: useCallback((props) => {

                return (
                    props?.value?.desktopImages?.imageUrl ?   <Box display="flex" gap={1}>
                        <Box display="flex" flexDirection="column">
                            <Typography variant='body2' fontSize="9px" fontWeight='normal' mb={0.125} style={{ color: '#9A9AAF', textTransform: 'capitalize' }}>Desktop</Typography>
                            {
                                props?.value?.desktopImages?.mediaType === 'image' ? (
                                    <img style={{ borderRadius: '6px', objectFit: "cover", overflow: "hidden" }} width="80px" height="40px" src={props?.value?.desktopImages?.imageUrl || defaultImage} alt={props?.value?.desktopImages?.altText || ''} />
                                ) : (
                                    <video
                                        controls
                                        style={{
                                            width: "80px",
                                            height: "40px",
                                            borderRadius: "6px",
                                            objectFit: "cover",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <source src={props?.value?.desktopImages?.imageUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )
                            }
                        </Box>

                        <Box display="flex" flexDirection="column">
                            <Typography variant='body2' fontSize="9px" fontWeight='normal' mb={0.125} style={{ color: '#9A9AAF', textTransform: 'capitalize' }}>Mobile</Typography>
                            {
                                props?.value?.mobileImages?.mediaType === 'image' ? (
                                    <img style={{ borderRadius: '6px', objectFit: "cover", overflow: "hidden" }} width="80px" height="40px" src={props?.value?.mobileImages?.imageUrl || defaultImage} alt={props?.value?.mobileImages?.altText || ''} />
                                ) : (
                                    <video
                                        controls
                                        style={{
                                            width: "80px",
                                            height: "40px",
                                            borderRadius: "6px",
                                            objectFit: "cover",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <source src={props?.value?.mobileImages?.imageUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )
                            }
                        </Box>
                </Box> : '-'
                );
            }, []),
            minWidth: 350,
            sortable: false,
        },
        {
            headerName: 'New Value',
            field: 'newChanges',
            suppressMenu: false,
            cellRenderer: useCallback((props) => {
                return (
                    props?.value?.desktopImages?.imageUrl ?   <Box display="flex" gap={1}>
                        <Box display="flex" flexDirection="column">
                            <Typography variant='body2' fontSize="9px" fontWeight='normal' mb={0.125} style={{ color: '#9A9AAF', textTransform: 'capitalize' }}>Desktop</Typography>
                            {
                                props?.value?.desktopImages?.mediaType === 'image' ? (
                                    <img style={{ borderRadius: '6px', objectFit: "cover", overflow: "hidden" }} width="80px" height="40px" src={props?.value?.desktopImages?.imageUrl || defaultImage} alt={props?.value?.desktopImages?.altText || ''} />
                                ) : (
                                    <video
                                        controls
                                        style={{
                                            width: "80px",
                                            height: "40px",
                                            borderRadius: "6px",
                                            objectFit: "cover",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <source src={props?.value?.desktopImages?.imageUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )
                            }
                        </Box>

                        <Box display="flex" flexDirection="column">
                            <Typography variant='body2' fontSize="9px" fontWeight='normal' mb={0.125} style={{ color: '#9A9AAF', textTransform: 'capitalize' }}>Mobile</Typography>
                            {
                                props?.value?.mobileImages?.mediaType === 'image' ? (
                                    <img style={{ borderRadius: '6px', objectFit: "cover", overflow: "hidden" }} width="80px" height="40px" src={props?.value?.mobileImages?.imageUrl || defaultImage} alt={props?.value?.mobileImages?.altText || ''} />
                                ) : (
                                    <video
                                        controls
                                        style={{
                                            width: "80px",
                                            height: "40px",
                                            borderRadius: "6px",
                                            objectFit: "cover",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <source src={props?.value?.mobileImages?.imageUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )
                            }
                        </Box>
                </Box>: '-'
                );
            }, []),
            minWidth: 350,
            sortable: false,
        },
        {
            headerName: 'User',
            field: 'updatedBy',
            minWidth: 180,
            cellRenderer: (props) => {
                return props?.value ? `${props?.value}` : '-';
            },
            flex: 1.3,
            sortable: false
        },
        {
            headerName: 'Time',
            field: 'createdDate',
            headerClass: 'right-aligned-cell-header',
            minWidth: 150,
            cellRenderer: useCallback((props) => (
                props?.value ? formatTimestampToDate24Hours(props?.value) : '-'
            ), []),
            flex: 1.3,
            sortable: false,
            cellStyle: { textAlign: 'right', justifyContent: 'end' },
        },
    ];

    const getRows = async (params) => {
        gridRefApi.current = params;
        dispatch(fetchBRBGraphicsLogs({ skip: pageRef.current, limit: 20, searchTerm: searchTermRef.current })).unwrap().then(res => {
            const { activityLogs, total } = res;

            params.successCallback([...activityLogs], total);
            pageRef.current = pageRef.current + 20;
        }).catch(() => { params.successCallback([], 0); });
    };

    const searchHandler = (searchValue) => {
        setSearchTerm(searchValue);
        searchTermRef.current = searchValue;
        handleSearch(searchValue);
        // Debounce the search callback
    };

    const handleSearch = useDebounce(() => {
        pageRef.current = 0;
        searchFn();
    }, 500);

    const searchFn = (value) => {
        const dataSource = {
            getRows: (params) => getRows(params, value) // Pass the current filter payload
        };
        if (mainGridApiRef.current) {
            mainGridApiRef.current.ensureIndexVisible(0, null);
            mainGridApiRef.current.setGridOption("datasource", dataSource);
        }
    };

    useEffect(() => {
        if (mainGridApiRef?.current) {
            if (loading) {
                mainGridApiRef.current.showLoadingOverlay();
            } else if (slotsLogs?.total === 0) {
                mainGridApiRef.current.showNoRowsOverlay();
            }
            else {
                mainGridApiRef.current.hideOverlay();
            }
        }
    }, [slotsLogs, loading]);

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }}>
                <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={2}>
                    <span onClick={() => navigate(-1)} className='cur-pointer'>
                        <Box display="flex" gap={1} alignItems="center" color='text.main' lineHeight={1}>
                            <AngleRightIcon fontSize="14px" />
                            <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                                Express Menu
                            </Typography>
                        </Box>
                    </span>
                </Stack>

                <Box p={{ xs: 0 }}>
                    <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={2}>
                        <Grid item xs={12} sm={4}>
                            <Typography variant='h4'>Activity Logs</Typography>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                                <TextField
                                    className="custom-search-field"
                                    placeholder="Search"
                                    label=""
                                    value={searchTerm}
                                    onChange={(e) => searchHandler(e.target.value)}
                                    sx={{ minWidth: "280px" }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton size="small">
                                                    <SearchIcon width="18px" height="18px" />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        endAdornment:
                                            searchTerm?.length > 0 ? (
                                                <InputAdornment>
                                                    <IconButton onClick={() => searchHandler("")} size="small">
                                                        <CloseRounded />
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : null,
                                    }}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>

                <AgGridTable col={columnDefs} getRows={getRows} mainGridApiRef={mainGridApiRef} pageRef={pageRef} isLoading={loading} style={{ height: '70vh' }} />
            </Box>
        </CommonLayout>
    );
}